import { useState } from 'react'

import { SelectOption } from 'components/Select'
import { Account } from 'features/globalSetup/types/workspaceBidder'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { BidderSlice } from '../../../types'
import { BidderSliceDTO, fromDTO, GET_BIDDERS } from './api'
import { Data, Variables } from './api/types'
import { UseGetBiddersForSelect } from './types'

export const useGetBiddersForSelect = (accountType: Account): UseGetBiddersForSelect => {
  const [options, setOptions] = useState<SelectOption<BidderSlice>[]>([])

  useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const {
        bidders: { nodes },
      } = data

      if (nodes && nodes.length > 0) {
        setOptions(nodes.map((bidder: BidderSliceDTO) => fromDTO(bidder, accountType)))
      }
    },
    query: GET_BIDDERS,
    variables: { accountType },
  })

  return options
}
